import React, { useState, useEffect, useContext } from "react";
import { Avatar, Badge } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { BellOutlined, UserOutlined } from "@ant-design/icons";
import { AppContext } from "../AppContext";
import { apiGetDashboard } from "../api/dashboard";

const Header = () => {
  const { state } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);

  const { displayName, profileImage, specialization } = state?.currentUser;

  const fetchUnreadCount = React.useCallback(async () => {
    try {
      const response = await apiGetDashboard(1);
      const count =
        response?.data?.notificationsCount || response?.notificationsCount || 0;
      setUnreadCount(count);
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  }, []);

  useEffect(() => {
    fetchUnreadCount();
  }, [fetchUnreadCount]);

  // Update unread count when user navigates back from notifications page
  useEffect(() => {
    if (location.pathname !== "/notifications") {
      fetchUnreadCount();
    }
  }, [location.pathname, fetchUnreadCount]);

  useEffect(() => {
    const handleNotificationReceived = () => {
      setUnreadCount((prevCount) => {
        const newCount = prevCount + 1;
        console.log(
          "[Header] Notification received - updating count:",
          prevCount,
          "->",
          newCount
        );
        return newCount;
      });
    };

    const handleNotificationClicked = () => {};

    window.addEventListener(
      "notification-received",
      handleNotificationReceived
    );
    window.addEventListener("notification-clicked", handleNotificationClicked);

    if ("serviceWorker" in navigator) {
      const handleServiceWorkerMessage = (event) => {
        if (event.data) {
          if (event.data.type === "NOTIFICATION_RECEIVED") {
            setUnreadCount((prevCount) => {
              const newCount = prevCount + 1;
              console.log(
                "[Header] Background notification received - updating count:",
                prevCount,
                "->",
                newCount
              );
              return newCount;
            });
          } else if (event.data.type === "NOTIFICATION_CLICK") {
          }
        }
      };
      navigator.serviceWorker.addEventListener(
        "message",
        handleServiceWorkerMessage
      );

      return () => {
        window.removeEventListener(
          "notification-received",
          handleNotificationReceived
        );
        window.removeEventListener(
          "notification-clicked",
          handleNotificationClicked
        );
        navigator.serviceWorker.removeEventListener(
          "message",
          handleServiceWorkerMessage
        );
      };
    }

    return () => {
      window.removeEventListener(
        "notification-received",
        handleNotificationReceived
      );
      window.removeEventListener(
        "notification-clicked",
        handleNotificationClicked
      );
    };
  }, []);

  const handleNotificationClick = () => {
    navigate("/notifications");
  };

  return (
    <div className=" bg-purple-600 flex items-center justify-end px-6 gap-4 sticky top-0 z-50 shadow-md rounded-b-[30px]">
      <div onClick={handleNotificationClick}>
        <Badge count={unreadCount} offset={[-5, 5]} overflowCount={99}>
          <BellOutlined className="text-white text-3xl cursor-pointer hover:text-gray-200 transition-colors" />
        </Badge>
      </div>
      <div className="flex items-center gap-3 px-3 py-2 rounded-lg transition-colors">
        <Avatar
          size={40}
          src={profileImage}
          style={{ backgroundColor: "#fff", color: "#7c3aed" }}
          icon={!profileImage && <UserOutlined />}
        />
        <div className="text-white">
          <div className="text-sm font-medium">{displayName}</div>
          <div className="text-xs text-gray-200">{specialization}</div>
        </div>
      </div>
    </div>
  );
};

export default Header;
